import type { OpenAPISpec, Response } from '@/types/openapi';

const RESPONSE_REF_PREFIX = '#/components/responses/';

// resolveResponse follows a response-level $ref into components.responses.
// It returns undefined when the ref points anywhere else or at nothing.
export function resolveResponse(response: Response, spec: OpenAPISpec): Response | undefined {
  if (!response.$ref) return response;
  if (!response.$ref.startsWith(RESPONSE_REF_PREFIX)) return undefined;
  return spec.components?.responses?.[response.$ref.slice(RESPONSE_REF_PREFIX.length)];
}
